import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { PAYMENT_LINK_TYPE } from "../../constants";

export default function PaymentLinkTypeSelect({
  paymentLinkTypeValue,
  onChangePaymentLinkTypeValue,
}) {
  return (
    <FormControl variant="outlined">
      <InputLabel>Tipo de Pagamento</InputLabel>
      <Select
        value={paymentLinkTypeValue}
        onChange={(e) => onChangePaymentLinkTypeValue(e.target.value)}
        label="Tipo de Pagamento"
      >
        <MenuItem value={PAYMENT_LINK_TYPE.PAYMENT_LINK}>
          Link de pagamento
        </MenuItem>
        <MenuItem value={PAYMENT_LINK_TYPE.RECURRENT}>Link Recorrente</MenuItem>
      </Select>
    </FormControl>
  );
}
